import styled from "styled-components";

export const StyledAdNetworkProgressBarWrapper = styled.div`
    min-width: 160px;
`;
